import React from 'react';

export interface AsureCloudBanner {
  heading: string,
  message?: string,
  linkAction?: () => void,
  linkDisplay?: string,
  linkUrl?: string,
  borderColor?: 'primary' | 'warning' | 'danger' | 'success' | 'info',
  className?: string
}
/* Banner requires heading.  Message, linkAction, linkUrl, and linkDisplay are optional */

export const AsureCloudBanner = ({ heading, message, linkAction, linkUrl, linkDisplay, borderColor, className }: AsureCloudBanner) => {
  return (
    <section className={`${message ? 'bannerHasMessage' : 'bannerHasHeaderOnly'} ACBanner cloud shadow-sm d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-start align-items-sm-center border-${borderColor} ${className}`}>
      <div className="messageArea d-flex flex-column justify-content-center align-items-start pb-sm-0 pb-1">
        <h1 className={`bannerHeading font-weight-bold m-0 ${message ? 'pb-2' : 'pb-0'}`}>{heading}</h1>
        <p className="bannerMessage m-0">{message}</p>
      </div>
      <div className="linkArea d-flex flex-column justify-content-center align-items-center">
        {linkUrl && <a href={linkUrl} className="card-link">{linkDisplay}</a>}
        {linkAction && <a href="#" onClick={linkAction} className="card-link">{linkDisplay}</a>}
      </div>
    </section>
  )
}

export default AsureCloudBanner;

AsureCloudBanner.defaultProps = {
  heading: 'Important Banner Heading',
  borderColor: 'primary',
  linkDisplay: 'Acknowledge',
}
